module.exports = __webpack_public_path__ + "static/media/ship.4c4d2991.png";